import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ELSButton } from "components/common/elsevier/Button/Button";
import { ELSDialog } from "components/common/elsevier/Dialog/Dialog";
import { selectUsersessionData } from "redux/reducers/userSessionReducer";
import { EvAuthApiApi } from "apiclient/api/EvAuthApiApi";
import useOnUnmount from "components/common/utils/useOnUnmount";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import styles from "./SessionTimeout.module.scss";
var WARN_THRESHOLD = 300000; // 5 minutes = 300,000 milliseconds
var INIT_TIMELEFT = 28800000; // 8 hours = 28,800,000 milliseconds

var authApi = new EvAuthApiApi();

/**
 * SessionTimeout component - monitors user activity and ends session after specified idle time.
 * @returns
 */
export default function SessionTimeout() {
  var _userSession$user;
  var userSession = useSelector(selectUsersessionData);
  var anon = (userSession === null || userSession === void 0 ? void 0 : (_userSession$user = userSession.user) === null || _userSession$user === void 0 ? void 0 : _userSession$user.userAnonymity) !== "INDIVIDUAL";
  var _useState = useState(INIT_TIMELEFT),
    timeLeft = _useState[0],
    setTimeLeft = _useState[1];
  var _useState2 = useState(false),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(0),
    intervalHandle = _useState3[0],
    setIntervalHandle = _useState3[1];
  useOnUnmount(function () {
    if (intervalHandle !== 0) {
      clearInterval(intervalHandle);
    }
  }, [intervalHandle]);
  var doTimeout = function doTimeout() {
    window.location = "/application/checksessionstatus?resourcetype=redirect&isIndividual=".concat(!anon);
  };

  // Reset to initial state
  var handleReset = function handleReset() {
    authApi.apiUser(); // touch the user session
    setTimeLeft(INIT_TIMELEFT);
  };
  var callTTL = function callTTL() {
    authApi.getSessionTTL().then(function (t) {
      setTimeLeft(parseInt(t, 10));
    })["catch"](function (error) {
      return console.error(error);
    });
  };
  useEffect(function () {
    setIntervalHandle(setInterval(callTTL, WARN_THRESHOLD));
  }, []);
  if (timeLeft < 20000) {
    doTimeout();
  } else if (timeLeft <= 2 * WARN_THRESHOLD) {
    if (timeLeft > WARN_THRESHOLD) {
      setTimeout(callTTL, timeLeft - 1 - WARN_THRESHOLD);
    } else if (!visible) {
      setTimeout(callTTL, timeLeft - 10000);
      setVisible(true);
    }
  } else if (visible) {
    setVisible(false);
  }

  // ***************************************************************************
  // Return JSX
  // ***************************************************************************
  return /*#__PURE__*/React.createElement(ELSDialog, {
    open: visible,
    className: styles["es-dialog"]
  }, /*#__PURE__*/React.createElement("p", null, "Due to inactivity, your session will expire in fewer than 5 minutes"), /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(ELSButton, {
    variant: "contained",
    onClick: handleReset,
    className: "es-button__primary"
  }, "Reset"))));
}